import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Edit3, Trash2, ExternalLink, Download, Copy } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminProposals() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  const load = () => api.get("/admin/proposals").then(setItems).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const create = async () => {
    const doc = await api.post("/admin/proposals", { title: "Nueva propuesta", year: String(new Date().getFullYear()), client_name: "Cliente" });
    nav(`/admin/proposals/${doc.id}`);
  };

  const duplicate = async (id) => {
    const doc = await api.post(`/admin/proposals/${id}/duplicate`, {});
    nav(`/admin/proposals/${doc.id}`);
  };

  const del = async (id) => {
    if (!window.confirm("¿Eliminar esta propuesta?")) return;
    await api.delete(`/admin/proposals/${id}`); load();
  };

  return (
    <div data-testid="admin-proposals">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-display text-4xl font-black tracking-tighter mb-1">Comercial · Propuestas</h1>
          <p className="text-sm text-muted-foreground">Crear, editar, exportar y compartir propuestas comerciales. Total: {items.length}</p>
        </div>
        <button onClick={create} data-testid="new-proposal" className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground rounded-sm font-semibold text-sm">
          <Plus className="w-4 h-4" /> Nueva propuesta
        </button>
      </div>

      <div className="border border-border rounded-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/50 text-xs uppercase tracking-widest">
            <tr><th className="text-left p-3">Título</th><th className="text-left p-3">Cliente</th><th className="text-left p-3">Año</th><th className="text-left p-3">Estado</th><th className="text-left p-3">Slug</th><th className="text-right p-3">Acciones</th></tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t border-border hover:bg-secondary/30">
                <td className="p-3 font-semibold">{p.title}</td>
                <td className="p-3">{p.client_name || "—"}</td>
                <td className="p-3">{p.year}</td>
                <td className="p-3"><span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-sm ${p.published ? "bg-primary text-primary-foreground" : "bg-secondary"}`}>{p.published ? "Publicada" : "Borrador"}</span></td>
                <td className="p-3 text-muted-foreground truncate max-w-xs"><code className="text-xs">{p.slug}</code></td>
                <td className="p-3 text-right">
                  {p.published && <Link to={`/propuesta/${p.slug}`} target="_blank" className="inline-flex items-center gap-1 px-3 py-1.5 border border-border rounded-sm text-xs font-semibold mr-2 hover:border-primary"><ExternalLink className="w-3 h-3" /> Ver</Link>}
                  <Link to={`/admin/proposals/${p.id}`} className="inline-flex items-center gap-1 px-3 py-1.5 border border-border rounded-sm text-xs font-semibold mr-2 hover:border-primary"><Edit3 className="w-3 h-3" /> Editar</Link>
                  <button onClick={() => duplicate(p.id)} data-testid={`duplicate-${p.id}`} className="inline-flex items-center gap-1 px-3 py-1.5 border border-border rounded-sm text-xs font-semibold mr-2 hover:border-primary"><Copy className="w-3 h-3" /> Duplicar</button>
                  <button onClick={() => del(p.id)} className="inline-flex items-center gap-1 px-3 py-1.5 border border-destructive/40 text-destructive rounded-sm text-xs font-semibold hover:bg-destructive/10"><Trash2 className="w-3 h-3" /> Eliminar</button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-muted-foreground">Sin propuestas. Click "Nueva propuesta" para empezar.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
